import { GlobalState } from '@leverege/ui-redux';
import { Toast, Dialogs } from '@leverege/ui-elements';
import UnpairedDialog from '../dashboard/viewer/theftRecovery/views/UnpairedDialog';

/**
 * 
 * @param {object} options
 * @param {string} options.locatorId
 * @param {string} options.locationId
 * @param {function} options.onClose
 */
export async function activate(options) {
  const {
    locatorId,
    locationId,
    companyId,
    onClose,
    onChange,
    throwErr,
    actions,
    contactInfo
  } = options;
  onChange?.({
    data: 'loading',
    value: true
  });
  GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    try {
      if (!locationId) {
        throw new Error('Vehicle is not associated to location');
      }
      if (!locatorId) {
        throw new Error('Vehicle is not associated to locator');
      }
      let nApi;
      if (companyId) {
        nApi = api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locations').obj(locationId).grp('locators').obj(locatorId).srv('recovr');
      } else {
        nApi = api.interface(process.env.SYSTEM_ID, 'location').obj(locationId).grp('locators').obj(locatorId).srv('recovr');
      }
      await nApi.post('activateTheftRecovery', {
        caseData: {
          contact: contactInfo
        }
      });
    } catch (error) {
      console.error(error);
      Toast.error(['Error activating theft recovery', error.message]);
      if (throwErr) {
        throw error;
      }
    }
    setTimeout(() => {
      GlobalState.dispatch(actions.get());
      onChange?.({
        data: 'loading',
        value: false
      });
      onClose?.();
    }, 2000);
  });
}
export async function deactivate(options) {
  const {
    locatorId,
    locationId,
    companyId,
    closeReason,
    goToTheft,
    actions,
    caseActions,
    throwErr,
    onChange,
    onClose
  } = options;
  onChange?.({
    data: 'loading',
    value: true
  });
  GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    let res;
    try {
      let nApi;
      if (companyId) {
        nApi = api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locations').obj(locationId).grp('locators').obj(locatorId).srv('recovr');
      } else {
        nApi = api.interface(process.env.SYSTEM_ID, 'location').obj(locationId).grp('locators').obj(locatorId).srv('recovr');
      }
      res = await nApi.post('deactivateTheftRecovery', {
        caseData: {
          closeReason: closeReason || 'N/A'
        }
      });
    } catch (error) {
      console.error(error);
      Toast.error(['Error activating theft recovery', error.message]);
      if (throwErr) {
        throw error;
      }
    }
    setTimeout(() => {
      GlobalState.dispatch(actions.get());
      if (goToTheft && caseActions) {
        GlobalState.dispatch(caseActions.parent().goTo());
      } else if (res?.locatorRemovedFromVehicle) {
        Dialogs.show({
          component: UnpairedDialog
        });
      }
      onChange?.({
        data: 'loading',
        value: false
      });
      onClose?.();
    }, 2000);
  });
}